import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertParseDateTime,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import {
  IuserGroup,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-user-profile-groups',
  templateUrl: './user-profile-groups.component.html',
  styleUrls: ['./user-profile-groups.component.scss'],
})
export class UserProfileGroupsComponent implements OnInit {
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() profileDetails!: IUserProfile;
  @Input() accessTimeFormGroupName!: string;
  @Input() selectedGroup!: IuserGroup;
  @Input() ownProfile!: boolean;
  @Output() selectedGroupChange = new EventEmitter<IuserGroup>();
  @Input() userGroups: IuserGroup[] = [];
  @Input() deleteGroupFlag!: boolean;
  @Output() deleteGroupFlagChange = new EventEmitter<boolean>();
  userType!: string | undefined;

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  userAccessformGroup!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private rootFormGroup: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.updateGroups();
    this.userGroups = this.profileDetails?.userGroups! || [];
    this.userType = this.profileDetails?.userType;
    this.userAccessformGroup = this.rootFormGroup.control.get(
      this.accessTimeFormGroupName
    ) as FormGroup;
    // this.createControls();
  }

  updateGroups() {
    this.userGroups = this.profileDetails?.userGroups! || [];
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description add new control for form control
   * @param controlName control name for creation
   * @returns void
   */
  addNewControl(controlName: string, required = false): void {
    let dCtrl = new FormControl();
    if (required) {
      dCtrl.setValidators(MFValidators.required);
    }
    this.userAccessformGroup.addControl(controlName, dCtrl);
    dCtrl.updateValueAndValidity();
  }

  editGroup(group: IuserGroup) {
    this.selectedGroupChange.emit((this.selectedGroup = group));

    if (group.repeatDays && group.repeatDays!.length > 0) {
      this.userAccessformGroup?.controls?.startTime?.patchValue('');
      this.userAccessformGroup?.controls?.expireTime?.patchValue('');
      this.addNewControl('repeatStartTime');
      this.addNewControl('repeatEndTime');
      this.addNewControl('repeatDays', true);
      this.userAccessformGroup?.patchValue({
        repeat: true,
        repeatDays: group.repeatDays,
        repeatStartTime: convertParseDateTime(
          group.repeatStartTime,
          'HH:mm',
          'hh:mm a'
        ),
        repeatEndTime: convertParseDateTime(
          group.repeatEndTime,
          'HH:mm',
          'hh:mm a'
        ),
      });
      this.userAccessformGroup?.controls?.repeatStartTime?.markAsTouched();
      this.userAccessformGroup?.controls?.repeatEndTime?.markAsTouched();
      this.userAccessformGroup?.controls?.repeatDays?.markAsTouched();
    } else {
      this.userAccessformGroup?.patchValue({
        repeat: false,
        startTime: convertParseDateTime(
          extractDateTimeFromDateString(String(group.startTime)),
          "yyyy-MM-dd'T'HH:mm:ss",
          "EEE, MMM do, yyyy 'at' h:mm a"
        ),
        expireTime: convertParseDateTime(
          extractDateTimeFromDateString(String(group.expireTime)),
          "yyyy-MM-dd'T'HH:mm:ss",
          "EEE, MMM do, yyyy 'at' h:mm a"
        ),
      });
    }
    this.deleteGroupFlagChange?.emit(true);
    this.stepperChange.emit((this.stepper += 1));
  }

  addGroup() {
    this.deleteGroupFlagChange?.emit(false);
    this.stepperChange.emit((this.stepper = 7));
  }
}
